var newsletters = {
	$this: $( '#newsletter' )
};

var submitting_newsletters_form = false;
var form_data = '';
var refresh = false;

newsletters.init = function() {

	newsletters.$this.submit( function( e ) {
		e.preventDefault();

		//prevent multiple submits
		if ( submitting_newsletters_form ) {
			return false;
		}
		submitting_newsletters_form = true;

		var $form = newsletters.$this.find('form');
		var submit_btn = $form.find('button[type="submit"]');

		form_data = $form.serialize();
		
		$.ajax({
			url: customData.ajaxURL,
			data: form_data,
			dataType: 'json',
			method: 'POST',
		})
		.done(function( data ) {

			newsletters.$this.find('.message').html( data.message ).show();

			var old_submit = newsletters.$this.find('button[type="submit"]' ).text();
 			
			submit_btn.blur();

			if ( ! data.success ) { 

				submit_btn.unbind( 'hover' );
				submit_btn.css({backgroundColor: '#ff0000', cursor: 'default'});
				submit_btn.html( 'Er ging iets mis' );

				submit_btn.animate({opacity: 1});

				refresh = true;

			} else {

				submit_btn.unbind( 'hover' );
				submit_btn.css({backgroundColor: '#446e03', cursor: 'default'});
				submit_btn.html( data.btn_message );
				submit_btn.animate({opacity: 1});

				submitting_newsletters_form = true;
				refresh = false;
			}

			//reset the button to normal state
			if( refresh ) {
				setTimeout(function(){

					submit_btn.animate({opacity: 0},500,function(){

						$(this).removeAttr('style');

						submit_btn.html( old_submit ); 

						submit_btn.animate({opacity: 1},500,function(){
							
							submitting_newsletters_form = false;
						});
					});
				},2000);
			}
		});
	} );
}

export { newsletters };
  